import { Link } from "react-router-dom";
import { Seo, localBusinessLD } from "../lib/seo";
import { POSTS } from "../data/content";
import { Reveal, SectionHead } from "../components/Reveal";
import { PageHero, CtaBand } from "../components/Shared";

export default function BlogPage() {
    return (
        <>
            <Seo
                title="Blog — Conseils peinture, parquet & carrelage dans l'Oise | Solino Pro"
                description="Conseils rénovation intérieure d'artisan : quel sol choisir pour une cuisine, prix de la peinture au m² dans l'Oise, parquet stratifié… Par Solino Pro, Chaumont-en-Vexin."
                path="/blog"
                jsonld={localBusinessLD()}
            />
            <PageHero
                img={POSTS[0].cover}
                crumb="Solino Pro — Journal de chantier"
                title="Conseils d'artisan,"
                serif="sans langue de bois."
            />

            <section className="mx-auto max-w-[1100px] px-5 sm:px-8 py-20 lg:py-28" data-testid="blog-list">
                <SectionHead
                    eyebrow="Le blog"
                    title="Ce qu'on aurait aimé lire"
                    serif="avant nos chantiers."
                />
                <div className="mt-14 space-y-6">
                    {POSTS.map((p, i) => (
                        <Reveal key={p.slug} delay={i * 0.06}>
                            <Link
                                to={`/blog/${p.slug}`}
                                className="group grid sm:grid-cols-[280px_1fr] gap-0 border border-linew bg-coal overflow-hidden hover:border-gold/50 transition-colors"
                                data-testid={`blog-card-${p.slug}`}
                            >
                                <div className="aspect-[16/10] sm:aspect-auto overflow-hidden">
                                    <img
                                        src={p.cover}
                                        alt=""
                                        loading="lazy"
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                                <div className="p-7 sm:p-9 flex flex-col justify-center">
                                    <p className="text-[10px] uppercase tracking-[0.25em] text-gold font-semibold">
                                        {new Date(p.date).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })} · {p.minRead} min
                                    </p>
                                    <h2 className="mt-3 text-xl sm:text-2xl font-light text-ivory leading-snug group-hover:text-gold transition-colors">
                                        {p.title}
                                    </h2>
                                    <p className="mt-3 text-sm text-smoke leading-relaxed">{p.excerpt}</p>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </section>

            <CtaBand />
        </>
    );
}
